import { render } from "./HomeView.vue?vue&type=template&id=dc99809e&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=dc99809e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Downloads\\ASKNC-Website\\asknc-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc99809e"]])

export default __exports__